import './leave-request.scss';

import phone from '@/pages/home/sections/leave-request/phone.svg';
import location from '@/pages/home/sections/leave-request/location.svg';
import email from '@/pages/home/sections/leave-request/email.svg';
import { useState } from 'react';
import { useSubmitCallMeLater } from '@/hooks/api';
import MySnackbar from '@/pages/home/sections/leave-request/components/my-snackbar';
import { Spinner } from '@/components/ui/spinner';
import { useLocales } from '@/locales';
import { PhoneNumInput } from '@/pages/home/sections/leave-request/components/phoneNumInput';
import { useErrorDialogDispatch } from '@/stores/errorDialogStore';

const defaultVal = {
  full_name: '',
  question: '',
  email: '',
  phone: '',
};

const supportPhone = import.meta.env.VITE_SUPPORT_PHONE || '+998(55) 506 45 54';
const supportEmail = import.meta.env.VITE_SUPPORT_EMAIL || 'info@eximerp.com';

const LeaveRequest = ({ passedRef }) => {
  const errorDispatch = useErrorDialogDispatch();

  const [formData, setFormData] = useState(defaultVal);
  const [snackbarState, setSnackbarState] = useState(false);

  const { translate } = useLocales();
  const handleChange = e => {
    const { name, value } = e.target;

    if (!name) return;

    setFormData(prev => ({
      ...prev,
      [name]: String(value),
    }));
  };

  const infoData = [
    {
      id: 1,
      title: translate('Phone'),
      subtitle: supportPhone,
      icon: phone,
    },
    {
      id: 2,
      title: translate('Address1'),
      subtitle: translate('Address'),
      icon: location,
    },
    {
      id: 3,
      title: translate('Email'),
      subtitle: supportEmail,
      icon: email,
    },
  ];

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarState(false);
  };

  // Submit call-me-later request using React Query hook
  const { mutate: submitRequest, isPending: sendingData } =
    useSubmitCallMeLater({
      onSuccess: response => {
        if (response?.data?.status === 'Success') {
          setTimeout(() => {
            setSnackbarState(true);
            setFormData(defaultVal);
          }, 2500);
        }
      },
      onError: () => {
        setTimeout(() => {
          errorDispatch({
            type: 'OPEN_ERROR_DIALOG',
            errorMsg: translate('systemError'),
          });
        }, 2500);
      },
    });

  const handleSubmit = e => {
    e.preventDefault();
    submitRequest({ ...formData });
  };

  return (
    <div ref={passedRef} className="leaveRequest">
      <div className="leaveRequest-contentWrapper">
        <div className="leaveRequest-container">
          <div className="leaveRequest-contents">
            <div className="leaveRequest-iframeWrapper">
              <iframe
                style={{
                  pointerEvents: 'auto',
                  overflow: 'hidden',
                  border: 'none',
                }}
                // ref={elementRefs.mapRef}
                // title="EximERPYandexMap"
                src="https://yandex.com/map-widget/v1/?azimuth=5.863518155906439&ll=69.317470%2C41.312076&mode=search&sctx=ZAAAAAgBEAAaKAoSCcueBDbnUVFAERGPxMvTp0RAEhIJnZ53Y0Fh0z8RqtOBrKdWxT8iBgABAgMEBSgKOABApZ8GSAFiJnJlbGV2X2ZpbHRlcl9hZHNfZHJhZ190b196b29tX3dpbmRvdz0xagJ1ep0BzcxMPaABAKgBAL0B0G8FYuoBAPIBAPgBAIICBkVyYU1lZIoCAJICAJoCDGRlc2t0b3AtbWFwcw%3D%3D&sll=69.317470%2C41.312076&sspn=0.000591%2C0.000326&text=EraMed&tilt=0.8726646259971648&whatshere%5Bpoint%5D=69.317449%2C41.312102&whatshere%5Bzoom%5D=17&z=17"
                allowFullScreen={true}
                title="our location"
              />
            </div>

            <div className="leaveRequest-formWrapper">
              <h3 className="leaveRequest-title">
                {translate('leave')} <span>{translate('request')}</span>
              </h3>
              <p className="leaveRequest-subtitle">
                {translate('leave_contact')}
              </p>
              <MySnackbar
                open={snackbarState}
                handleClose={handleClose}
                text="Отправлено"
              />
              <form className="leaveRequest-form" onSubmit={handleSubmit}>
                <input
                  onChange={handleChange}
                  value={formData.full_name}
                  minLength={4}
                  required
                  name="full_name"
                  type="text"
                  placeholder={translate('name_place')}
                />
                <PhoneNumInput
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                />
                {/* <input
                  onChange={handleChange}
                  value={formData.phone}
                  name="phone"
                  required
                  minLength={7}
                  type="number"
                  placeholder="+998 ( _ _ ) _ _ _ - _ _ - _ _"
                /> */}
                <input
                  onChange={handleChange}
                  value={formData.email}
                  name="email"
                  required
                  type="email"
                  placeholder={translate('Email')}
                />
                <textarea
                  onChange={handleChange}
                  value={formData.question}
                  name="question"
                  minLength={10}
                  required
                  placeholder={translate('write_q')}
                ></textarea>
                <button className="send-info">
                  {sendingData ? (
                    <Spinner size={24} color="#bbdefb" />
                  ) : (
                    translate('Send')
                  )}{' '}
                </button>
              </form>
              <div className="leaveRequest-formWrapper__infos">
                {infoData.map(item => {
                  return (
                    <div
                      key={item.id}
                      className="leaveRequest-formWrapper__infos-item"
                    >
                      <div className="icon">
                        <img src={item.icon} alt={item.title} />
                      </div>
                      <div className="text">
                        <h6 className="text-title">{item.title}</h6>
                        <p className="text-subtitle">{item.subtitle}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeaveRequest;
